import { Link } from "../components/shared/SiteLink";

export function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-6xl text-zap mb-4" style={{ fontWeight: 700 }}>404</h1>
        <h2 className="text-2xl text-zap-navy mb-4" style={{ fontWeight: 600 }}>העמוד לא נמצא</h2>
        <p className="text-gray-500 mb-8">מצטערים, העמוד שחיפשתם אינו קיים.</p>
        <Link
          to="/"
          className="inline-flex items-center px-6 py-3 bg-zap text-white rounded-lg hover:bg-zap-dark transition-colors text-sm"
          style={{ fontWeight: 500 }}
        >
          חזרה לדף הבית
        </Link>
      </div>
    </div>
  );
}